import { render, staticRenderFns } from "./EditFormViewRegistrants.vue?vue&type=template&id=500cfbd0"
import script from "./EditFormViewRegistrants.vue?vue&type=script&lang=js"
export * from "./EditFormViewRegistrants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports